var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "c2d61cd18292db7999b9443fa0bf345fb1b2d622"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["realtyoffer@tonymamo"] = {
  id: "c2d61cd18292db7999b9443fa0bf345fb1b2d622"
};